import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'selectLearningItemsStep',
    'confirmExpectedTransactionStep',
    'finalStep',
    'selectLearningItemsForm',
    'content',
    'submitButton',
    'form',
    'collaboratorCheckboxes'
  ]

  connect() {
    this.enableReloadPage = false
    this.modalCloseButton = this.element.closest('.modal')?.querySelector('button[data-action="click->modal#close"]')
    this.modalCloseButton?.addEventListener('click', this.reloadPage.bind(this))
  }

  disconnect() {
    this.modalCloseButton?.removeEventListener('click', this.reloadPage.bind(this))
  }

  reloadPage() {
    if (!this.enableReloadPage) return
    window.location.reload()
  }

  validate(event) {
    setTimeout(() => {
      var formData = Object.fromEntries(new FormData(this.selectLearningItemsFormTarget).entries());
      let learningItemGlobalProductIds = formData['learning_item_global_product_ids[]']
      if (learningItemGlobalProductIds) {
        this.submitButtonTarget.classList.add('btn-active-primary')
        this.submitButtonTarget.classList.remove('disabled')
        this.submitButtonTarget.disabled = false
      } else {
        this.submitButtonTarget.classList.remove('btn-active-primary')
        this.submitButtonTarget.classList.add('disabled')
        this.submitButtonTarget.disabled = true
      }
    }, 10)
  }

  applyClasses(item) {
    this.selectLearningItemsStepTarget.classList.remove('border-bg-primary')
    this.selectLearningItemsStepTarget.classList.add('border-transparent')
    this.confirmExpectedTransactionStepTarget.classList.remove('border-bg-primary')
    this.confirmExpectedTransactionStepTarget.classList.add('border-transparent')
    this.finalStepTarget.classList.remove('border-bg-primary')
    this.finalStepTarget.classList.add('border-transparent')
    const icon = item.querySelector('.step-icon')
    const stepNumber = item.querySelector('.step-number')
    item.classList.remove('border-transparent')
    item.classList.add('border-bg-primary')
    icon.classList.remove('bg-transparent')
    icon.classList.add('bg-primary')
    stepNumber.classList.remove('bg-primary-as-text')
    stepNumber.classList.add('text-white')
  }

  resultSelectLearningItems(event){
    // event is ajax success

    const [, , xhr] = event.detail;
    if (xhr.response.length > 0) {
      this.applyClasses(this.confirmExpectedTransactionStepTarget)
      return this.contentTarget.innerHTML = xhr.response
    }
  }

  errorSelectLearningItems(event) {
    const [, , xhr] = event.detail;
    if (xhr.status == 402){
      // TODO add i18n yarn package https://stackoverflow.com/questions/59181356/how-to-use-i18n-js-with-webpacker-in-rails-6
      return alert("You don't have enough credit to perform that operation")
    }
  }

  resultSubmitRegistrations(event){
    // event is ajax success
    const [, , xhr] = event.detail;
    if (xhr.response.length > 0) {
      this.applyClasses(this.finalStepTarget)
      this.enableReloadPage = true
      return this.contentTarget.innerHTML = xhr.response
    }
  }
}
